<div class="navigation-menu">
  @for(item of navigationItems; track $index) {
    <div
      [class.border-right]="isProfile(item)"
      [class.white]="isProfile(item)"
      [class.border-bottom-400]="isProfile(item)"
      [class.margin-bottom]="isProfile(item)"
      class="navigation-item" 
      style="--width:{{ 100/navigationItems.length }}%">
      <app-left-navigation-item [item]="item" (clickedItem)="handleItemClick($event)"/>
    </div>
  }
</div>